import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
/* eslint-disable ember/no-computed-properties-in-native-classes */
import { action, computed } from '@ember/object';
import { ensureSafeComponent } from '@embroider/util';
import Component from '@glimmer/component';
// @ts-expect-error: Incorrect type
import preventDefault from 'ember-event-helpers/helpers/prevent-default';

interface GeneralListsListItemsListItemExpandableSignature {
  Args: {
    expandComponent: unknown;
    isLoading: unknown;
    listActions: unknown;
    onOpenExpandView: unknown;
    option: unknown;
  };
}

export default class GeneralListsListItemsListItemExpandable extends Component<GeneralListsListItemsListItemExpandableSignature> {
  @computed('args.option.isExpanded')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isExpanded() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.option?.isExpanded;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showExpandContent() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.expandComponent && this.isExpanded;
  }

  @action
  // @ts-expect-error: Incorrect type
  openExpandView(option): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.onOpenExpandView(option, option.isExpanded);
  }

  <template>
    {{! @glint-nocheck }}
    <div class="list-item-expandable">
      <div
        class="list-item-expandable-button"
        role="button"
        {{on "click" (preventDefault (fn this.openExpandView @option))}}
      >
        {{component
          (ensureSafeComponent @option.listItemComponent)
          isLoading=@isLoading
          listActions=@listActions
          params=@option
        }}
        {{component
          (ensureSafeComponent @option.expandActionComponent)
          isExpanded=this.isExpanded
          isLoading=@isLoading
          listActions=@listActions
        }}
      </div>
      {{#if this.showExpandContent}}
        <div>
          {{component
            (ensureSafeComponent @expandComponent)
            isLoading=@isLoading
            listActions=@listActions
            params=@option
          }}
        </div>
      {{/if}}
    </div>
  </template>
}
